// import Vue from 'vue'
const state = {
  viewMode: window.localStorage.getItem('viewMode') || 'table', // detail
  functions: {
    right: [],
    left: []
  },
  views: {},
  apps: [],
  user: null,
  loading: {
    funcList: false
  }
}
// getters
const getters = {
}

// actions
const actions = {
  setMode ({ commit }, view) {
    commit('setMode', view)
  },
  setApps ({ commit }, payload) {
    commit('setApps', payload)
  },
  removeApp ({ commit }, app) {
    commit('removeApp', app)
  },
  rightManager ({ commit }, payload) {
    commit('rightManager', payload)
  },
  leftManager ({ commit }, payload) {
    commit('leftManager', payload)
  },
  syncFeat ({ commit }, payload) {
    commit('syncFeat', payload)
  },
  setUser ({ commit }, payload) {
    commit('setUser', payload)
  },
  setLeft ({ commit }, payload) {
    commit('setLeft', payload)
  },
  setRight ({ commit }, payload) {
    commit('setRight', payload)
  },
  reset ({ commit }, payload) {
    commit('reset', payload)
  },
  setLoading ({ commit }, payload) {
    commit('setLoading', payload)
  }
}

function compalize (f, payload, id = 'feature_id') {
  // console.log('compalize', f._id, payload._id)
  return f._id === payload._id || f[id] === payload._id
}

// mutations
const mutations = {
  reset (state) {
    state.functions.right = []
    state.functions.left = []
    state.views = []
    state.apps = []
  },
  setMode (state, view) {
    state.viewMode = view
    window.localStorage.setItem('viewMode', view)
  },
  setLoading (state, { action, payload }) {
    if (action in state.loading) {
      state.loading[action] = payload
    }
  },
  setUser (state, user) {
    state.user = user
  },
  leftManager (state, { action, payload, featureId, type }) {
    switch (action) {
      case 'cancel':
        if (!featureId) return
        let feat = state.functions.left.find(f => f._id === featureId)
        if (!feat) return
        if (type === 'feature') {
          feat.isShow = 0
          // eslint-disable-next-line no-return-assign
          feat.functions.some(x => x.isShow = 0)
        } else if (type === 'function') {
          let cancel = true
          feat.functions.map(f => {
            if (f._id === payload.function_id) {
              f.isShow = 0
            }
            if (f.isShow) {
              cancel = false
            }
          })
          if (cancel) feat.isShow = 0
        }
        break
      case 'init':
        state.functions.left = payload
        break
      default:
        break
    }
  },
  rightManager (state, { action, payload, parent, idx = -1, funcIdx = -1, target }) {
    // const p = parent ? parent.functions : state.functions.right
    var index = -1
    var featuresCache
    var featCount
    switch (action) {
      case 'add':
        if (!parent) {
          // 1级功能
          if (index === -1) {
            idx = idx === -1 ? state.functions.right.length : idx
            console.log('[ADD FEAT INDEX]', idx, payload)
            state.functions.right.splice(idx, 0, payload)
          } else {
            if (state.functions.right[index].functions.length === 0) {
              payload.functions.forEach(fun => {
                state.functions.right[index].functions.push(fun)
              })
            }
          }
        } else {
          const feature = state.functions.right.find(f => compalize(f, parent))
          if (feature) {
            idx = idx === -1 ? feature.functions.length : idx
            console.log('func index', payload)
            feature.functions.splice(idx, 0, payload)
          } else {
            parent.functions = parent.functions.filter(x => Boolean(parseInt(x.isShow)))
            state.functions.right.push(parent)
          }
        }
        break
      case 'del':
        if (parent) {
          console.log('dele', parent)
          index = state.functions.right.findIndex(f => compalize(f, parent))
          console.log('parent index', index)
          if (index > -1) {
            const feature = state.functions.right[index]
            idx = feature.functions.findIndex(fn => compalize(fn, payload, 'function_id'))
            if (idx > -1) {
              feature.functions.splice(idx, 1)
            }
            if (feature.functions.length === 0) {
              state.functions.right.splice(index, 1)
            }
          }
        } else {
          index = state.functions.right.findIndex(f => compalize(f, payload))
          console.log('dele', idx, index, payload)
          if (index > -1) {
            state.functions.right.splice(index, 1)
            console.log(state.functions.right.map(x => x.name))
          }
        }
        break
      case 'update':
        state.functions.right = payload
        break
      case 'updateItem':
        state.functions.right[idx].functions = payload
        break
      case 'empty':
        state.functions.right = []
        break
      case 'init':
        state.functions.right = payload
        break
      case 'addAll':
        idx = idx === -1 ? state.functions.right.length : idx + 1

        featuresCache = state.functions.right.reduce((l, f) => {
          l[f.feature_id] = f
          return l
        }, {})
        featCount = 0
        // M
        state.functions.left.forEach((feat, index) => {
          // 1级功能全没选的情况
          if (!parseInt(feat.isShow)) {
            state.functions.right.splice(idx + featCount, 0, feat)
            feat.isShow = 1
            // eslint-disable-next-line no-return-assign
            feat.functions.every(x => x.isShow = 1)
            featCount++
          } else {
            // TODO: 此处可以优化，反复查找
            // let feature = state.functions.right.find(f => compalize(f, feat, 'feature_id'))
            let feature = featuresCache[feat._id]
            console.log('finded index', feature)
            if (feature) {
              funcIdx = funcIdx === -1 ? feature.functions.length : funcIdx + 1
              let addCount = 0
              feat.functions.forEach((ff, index) => {
                if (!parseInt(ff.isShow)) {
                  feature.functions.splice(funcIdx + addCount, 0, ff)
                  ff.isShow = 1
                  addCount++
                }
              })
            }
          }
        })
        break
      // case 'removeAll':
      //   idx = idx === -1 ? state.functions.right.length : idx + 1
      //
      //   featuresCache = state.functions.right.reduce((l, f) => {
      //     l[f.feature_id] = f
      //     return l
      //   }, {})
      //   featCount = 0
      //   // M
      //   state.functions.left.forEach((feat, index) => {
      //     // 1级功能全选的情况
      //     if (parseInt(feat.isShow)) {
      //       state.functions.right.splice(idx + featCount, 0, feat)
      //       feat.isShow = 1
      //       // eslint-disable-next-line no-return-assign
      //       feat.functions.every(x => x.isShow = 1)
      //       featCount++
      //     } else {
      //       // TODO: 此处可以优化，反复查找
      //       // let feature = state.functions.right.find(f => compalize(f, feat, 'feature_id'))
      //       let feature = featuresCache[feat._id]
      //       console.log('finded index', feature)
      //       if (feature) {
      //         funcIdx = funcIdx === -1 ? feature.functions.length : funcIdx + 1
      //         let addCount = 0
      //         feat.functions.forEach((ff, index) => {
      //           if (!parseInt(ff.isShow)) {
      //             feature.functions.splice(funcIdx + addCount, 0, ff)
      //             ff.isShow = 1
      //             addCount++
      //           }
      //         })
      //       }
      //     }
      //   })
      //   break
      default:
        //
    }
  },
  setApps (state, payload) {
    state.apps = payload
  },
  removeApp (state, app) {
    const index = state.apps.indexOf(app)
    if (index > -1) {
      state.apps.splice(index, 1)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
